<template>
  <!-- Easy cash Area -->
  <section id="QuotationSection" class="easy_cash_area cot-credict">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 back-form">
          <form class="from_main" action="php/contact.php" method="post" id="phpcontactform" novalidate="novalidate">
            <div class="row">
              <div class="col-lg-12 select_from">
                <h6 class="col-lg-7">¿Cuánto cuesta el vehículo?</h6>
                <div class="input-group mb-2 col-lg-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text  form-control">$</div>
                  </div>
                  <input type="text" class=" form-control" id="precio" name="precio" v-model="masck.vehiclePrice"
                    v-mask="numberMask" :class="{
                      error:
                        $v.form.vehiclePrice.$dirty &&
                        $v.form.vehiclePrice.$invalid
                    }" required @blur="
  $v.form.vehiclePrice.$touch();
form.vehiclePrice = masck.vehiclePrice.replace(/\D+/g, '');
masck.vehicleHitch = (form.vehiclePrice / 100) * 20;
" />
                </div>
              </div>
              <div class="col-lg-12 select_from">
                <h6 class="col-lg-7">¿Cuánto puedes dar de enganche?</h6>
                <div class="input-group mb-2 col-lg-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text  form-control">$</div>
                  </div>
                  <input type="text" class="form-control" id="enganche" name="enganche" v-model="masck.vehicleHitch"
                    v-mask="numberMask" :class="{
                      error:
                        $v.form.vehicleHitch.$dirty &&
                        $v.form.vehicleHitch.$invalid
                    }" required @input="
  $v.form.vehicleHitch.$touch();
form.vehicleHitch = masck.vehicleHitch.replace(/\D+/g, '');
porcentaje = (form.vehicleHitch / form.vehiclePrice) * 100;
" />
                </div>
                <div class="col-8">
                  <span><small>Se necesita mínimo el <b>20%</b> de enganche</small>
                  </span>
                </div>
                <div class="col-4 p-2">
                  <span class="d-flex flex-column align-items-end ">
                    <b :class="{
                      'text-danger':
                        porcentaje.toFixed(2) < 20.0 ||
                        porcentaje.toFixed(2) > 70,
                      'd-none': porcentaje.toFixed(2) == 'NaN',
                      'text-success':
                        porcentaje.toFixed(2) >= 20.0 &&
                        porcentaje.toFixed(2) <= 70
                    }">
                      {{ this.porcentaje.toFixed(2) }}%
                    </b>
                  </span>
                </div>
                <div class="col-12 row">
                  <input class="col-12 p-0" type="range" v-model="form.vehicleHitch"
                    :disabled="porcentaje.toFixed(2) == 'NaN'" :min="(form.vehiclePrice / 100) * 20"
                    :max="(form.vehiclePrice / 100) * 70" autocomplete="off" @input="
                      masck.vehicleHitch = form.vehicleHitch;
                    porcentaje = (form.vehicleHitch / form.vehiclePrice) * 100;
                    " />
                  <div class="col-6">
                    <span><b>{{
                      ((form.vehiclePrice / 100) * 20) | VMask(numberMask)
                    }}</b></span>
                  </div>
                  <div class="col-6 p-0">
                    <span class="d-flex flex-column align-items-end ">
                      <b class="align-self-end">{{
                        ((form.vehiclePrice / 100) * 70) | VMask(numberMask)
                      }}</b>
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <p>
                  *El valor del pago mensual es estimado y no incluye valor del
                  seguro.
                </p>
                <br />
              </div>

              <div class=" col-12 p-0 m-0">
                <img src="../../../images/img/contrato_azul2.png" class="rounded" width="230px" />
              </div>
              <!-- <div class="form-group">
                            <button class="theme_btn btn" id="js-contact-btn" type="submit">Enviar</button>
                            <div id="js-contact-result" data-success-msg="Form submitted successfully." data-error-msg="Messages Successfully"></div>
                        </div> -->
            </div>
          </form>
        </div>
        <div class="col-lg-5 text-center">
          <div class="your_results">
            <h3>Simula tu crédito</h3>
            <hr />
            <div>
              <h4 class="ra text-your_results">Requieres financiar</h4>
              <h4>
                <span>${{
                  form.vehiclePrice == 0
                  ? "--"
                  : formatPrice(form.vehiclePrice - form.vehicleHitch)
                }}</span>
              </h4>
            </div>
            <br />
            <div class="form">
              <form>
                <fieldset class="form__options">
                  <h4 class="ra text-your_results">
                    Selecciona el plazo deseado en meses
                  </h4>
                  <p class="form__answer">
                    <input type="radio" name="match" id="match_1" value="12" v-model="form.monthsNumber" />
                    <label for="match_1">
                      12
                    </label>
                  </p>
                  <p class="form__answer">
                    <input type="radio" name="match" id="match_2" value="24" v-model="form.monthsNumber" />
                    <label for="match_2">
                      24
                    </label>
                  </p>
                  <p class="form__answer">
                    <input type="radio" name="match" id="match_3" value="36" v-model="form.monthsNumber" />
                    <label for="match_3">
                      36
                    </label>
                  </p>
                  <p class="form__answer">
                    <input type="radio" name="match" id="match_4" value="48" v-model="form.monthsNumber" checked />
                    <label for="match_4">
                      48
                    </label>
                  </p>
                </fieldset>
              </form>
            </div>

            <div class="col-12 white-hr">
              <hr />
            </div>

            <div>
              <h4 class="ra text-your_results">Pago mensual aproximado*</h4>
              <h4>
                <span>${{
                  form.vehiclePrice == 0
                  ? "--"
                  : formatPrice(
                    (form.vehiclePrice - form.vehicleHitch) /
                    form.monthsNumber +
                    ((form.vehiclePrice - form.vehicleHitch) / 100) *
                    TASA +
                    (CalculateGPS()) +
                    (CalculateSEGURODEUDOR())
                  )
                }}</span>
              </h4>
            </div>
            <br />
            <div class="col-12">
              <button class="col-12 theme_btn btn btn-block" style="width: 100%" :disabled="$v.form.$invalid"
                v-on:click="createCreditQuotation(2)">
                Solicitar crédito
              </button>
              <button class="d-flex btn text-white ml-auto mt-auto m-0 p-0" :disabled="$v.form.$invalid"
                v-on:click="createCreditQuotation(1)">
                Descargar cotización <i class="fa fa-download m-0 p-2"> </i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  required,
  minLength,
  minValue,
  maxValue
} from "vuelidate/lib/validators";
import Environments from "../../environments/Environment";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { ref } from 'vue';

const numberMask = createNumberMask({
  prefix: "",
  includeThousandsSeparator: true,
  allowNegative: false
});

export default {
  name: "Quotation",
  data() {
    return {
      TASA: Environments.TASA,
      GPS: Environments.GPS,
      SEGURODEUDOR: Environments.SEGURODEUDOR,
      numberMask,
      models: [],
      brands: [],
      versions: [],
      descriptions: [],
      porcentaje: 0,
      masck: {
        vehiclePrice: 0,
        vehicleHitch: 0,
        dependent: 0
      },
      form: {
        selectedDescription: "",
        vehiclePrice: 0,
        vehicleHitch: 0,
        monthsNumber: 48
      },
      contactForm: {
        name: "",
        email: "",
        subject: "",
        text: ""
      }
    };
  },
  validations() {
    return {
      form: {
        vehiclePrice: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(2000000),
          $lazy: true
        },
        vehicleHitch: {
          required,
          minValue: minValue((this.form.vehiclePrice / 100) * 20),
          maxValue: maxValue(this.form.vehiclePrice),
          $lazy: true
        }
      },
      contactForm: {
        name: { required },
        email: { required },
        subject: { required },
        text: { required }
      }
    };
  },
  methods: {
    sendContact() {
      var data = {
        data: {
          name: this.contactForm.name,
          email: this.contactForm.email,
          subject: this.contactForm.subject,
          message: this.contactForm.text
        }
      };
      this.$InsuranceService.sendContact(data).then(
        result => {
          this.$swal("Exito, su petición ha sido enviada con exito");
          this.contactForm.name = "";
          this.contactForm.email = "";
          this.contactForm.subject = "";
          this.contactForm.text = "";
          window.scrollTo(0, 0);
        },
        err => {
          this.$swal(err.msg);
        }
      );
    },
    status(validation) {
      return validation.$invalid;
    },
    refreshSelects() {
      $("#model").niceSelect("update");
      $("#brand").niceSelect("update");
      $("#version").niceSelect("update");
      $("#description").niceSelect("update");
    },
    getModels() {
      this.$InsuranceService.getModels().then(
        result => {
          this.models = result.data.model.slice(0, 14);
          setTimeout(() => {
            this.refreshSelects();

            $("#model").on("change", () => {
              this.form.selectedModel = $("#model").val();
              $("#brand").val("");
              $("#version").val("");
              $("#description").val("");
              this.form.selectedBrand = "";
              this.form.selectedVersion = "";
              this.form.selectedDescription = "";

              this.getBrands();

              setTimeout(() => {
                this.refreshSelects();
              }, 100);
            });
          }, 100);
        },
        err => this.$swal(err.msg)
      );
    },
    getBrands() {
      if (this.form.selectedModel != "") {
        const data = {
          model: this.form.selectedModel
        };

        this.$InsuranceService.getBrands(data).then(
          result => {
            this.brands = result.data.brand;

            setTimeout(() => {
              this.refreshSelects();

              $("#brand").on("change", () => {
                this.form.selectedBrand = $("#brand").val();
                $("#version").val("");
                $("#description").val("");
                this.form.selectedVersion = "";
                this.form.selectedDescription = "";

                this.getVersions();

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          },
          err => this.$swal(err.msg)
        );
      }
    },
    getVersions() {
      if (this.form.selectedBrand != "") {
        const data = {
          model: this.form.selectedModel,
          brand: this.form.selectedBrand
        };

        this.$InsuranceService.getVersions(data).then(
          result => {
            this.versions = result.data.version;

            setTimeout(() => {
              this.refreshSelects();

              $("#version").on("change", () => {
                this.form.selectedVersion = $("#version").val();
                $("#description").val("");
                this.form.selectedDescription = "";

                this.getDescriptions();
                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          },
          err => this.$swal(err.msg)
        );
      }
    },
    getDescriptions() {
      if (this.form.selectedVersion != "") {
        const data = {
          model: this.form.selectedModel,
          brand: this.form.selectedBrand,
          version: this.form.selectedVersion
        };

        this.$InsuranceService.getDescriptions(data).then(
          result => {
            this.descriptions = result.data.description;

            setTimeout(() => {
              this.refreshSelects();

              $("#description").on("change", () => {
                this.form.selectedDescription = $("#description").val();

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          },
          err => this.$swal(err.msg)
        );
      }
    },
    getQuotation() {
      this.$UserService.getCreditQuotation().then(
        result => {
          if (result.data.length > 0) {
            this.form.vehiclePrice = result.data[0].vehicle_price;
            this.masck.vehiclePrice = result.data[0].vehicle_price;
            this.form.vehicleHitch = result.data[0].vehicle_hitch;
            this.masck.vehicleHitch = result.data[0].vehicle_hitch;
            this.form.monthsNumber = result.data[0].months;
          }
          //this.preloaderHiden();
        },
        err => {
          //this.preloaderHiden();
          //this.$swal("CUIDADO!", err.msg, "error");
        }
      );
    },
    CalculateGPS(){
      let financed =  this.form.vehiclePrice - this.form.vehicleHitch ;
      console.log(this.form.vehicleHitch);
      console.log( this.form.vehiclePrice);
      console.log(financed);
      if(financed >= 1 && financed <= 300000){
        return 260.00;
      }else if(financed >= 300001 && financed <= 500000){
         return 260.00;
      }else {
        return 598.00;
      }
    },
    CalculateSEGURODEUDOR(){
       let financed =  this.form.vehiclePrice - this.form.vehicleHitch ;
      console.log(this.form.vehicleHitch);
      console.log( this.form.vehiclePrice);
      console.log(financed);
      if(financed >= 1 && financed <= 300000){
        return 142.00;
      }else if(financed >= 300001 && financed <= 500000){
         return 162.00;
      }else {
        return 232.00;
      }
    },
    createCreditQuotation(button) {
      this.preloader();

      const data = {
        id: 0,
        user_id: localStorage.getItem("id"),
        vehicle_price: Number(this.form.vehiclePrice),
        vehicle_hitch: Number(this.form.vehicleHitch),
        months: Number(this.form.monthsNumber),
        requested_amount_credit: Number(
          this.form.vehiclePrice - this.form.vehicleHitch
        ),
        monthly_payment: Number(
          (this.form.vehiclePrice - this.form.vehicleHitch) /
          this.form.monthsNumber +
          ((this.form.vehiclePrice - this.form.vehicleHitch) / 100) *
          this.TASA +
          this.GPS +
          this.SEGURODEUDOR
        )
      };

      if (data.user_id != null) {
          this.$UserService.createCreditQuotation({ data: data }).then(
           result => {
          /* this.$emit("next", {}); */
          console.log("--------createCreditQuotation-----", result);
          localStorage.setItem('quote_credit', result.data.insertId);
            this.preloaderHiden();
            console.log("--------approval-----");
            window.location = '/pre-approval';
          }, err => {
              console.log("--------error-----");
              console.log(err.msg);
              //this.$swal(err.msg);
              this.preloaderHiden();
            }).catch(error => { console.log("error - ", error);});
        } else {
            this.preloaderHiden();
            console.log("--------create-----");
            localStorage.setItem('quote_data', JSON.stringify(data));

            if (button == 1) {
              window.location = '/CotizacionTradicional';
            } else {
              window.location = '/create-account';
            }

          }
    },
    formatPrice(value) {
      let num = (value / 1).toFixed(0);
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  mounted() {
    var element = document.getElementById("headerComponent");
    element.classList.add("d-none");
    var element = document.getElementById("footerComponent");
    element.classList.add("d-none");
    var element = document.getElementById("QuotationSection");
    element.classList.add("mt-0");
    window.scrollTo(0, 250);
  },
  created() {

    this.getQuotation();
    window.scrollTo(0, 0);
    //this.getModels();
  }
};
</script>

<style lang="scss">
.error {
  border-color: red !important;
  background: #fdd;
}

.error:focus {
  outline-color: #f99;
}

.nice-select .current {
  width: -webkit-fill-available !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.error {
  border-color: red !important;
  background: #FDD;
}

.error:focus {
  outline-color: #F99;
}

.nice-select .current {
  width: -webkit-fill-available !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.step-progress__bar {
  align-items: center;
  display: flex;
  height: 100px;
  justify-content: space-between;
  margin-bottom: 0px !important;
  width: 100%;
}

.bg-menu {
  background: #55988D !important;
  box-shadow: 5px 5px 40px;
  /* Sombra con un desenfoque casi disipado */
}

@media (max-width: 600px) {
  .step-progress__bar {
    height: 50px;
  }

  .bg-menu {
    background: transparent !important;
    box-shadow: 0px 0px 0px;
    /* Sombra con un desenfoque casi disipado */
  }

  .header_menu {
    box-shadow: 10px 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/GrayZone/QuotationSection.vue